"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importStar(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const HelperUtils_1 = require("utils/HelperUtils");
const Objective_1 = __importDefault(require("components/objectives/Objective"));
const objective_detail_1 = __importDefault(require("../../../../../cypress/fixtures/objective/objective-detail"));
const HighlightedIllustration = () => {
    const newObj = Object.assign(Object.assign({}, objective_detail_1.default.data), { id: 1, name: 'Example Goal', weight: null, tags: [], isHighlighted: false, valueLastUpdatedAt: (0, dayjs_1.default)().subtract(7, 'day').toISOString(), involvements: [
            Object.assign(Object.assign({}, objective_detail_1.default.data.involvements[0]), { role: 'assignee', userId: 1, visible: true, user: Object.assign(Object.assign({}, objective_detail_1.default.data.involvements[0].user), { id: 1, name: 'Goal Owner', title: 'Employee' }) })
        ], permissions: [...objective_detail_1.default.data.permissions, 'highlight'], parent: Object.assign(Object.assign({}, objective_detail_1.default.data), { id: 12, name: 'Example parent goals' }) });
    const activityData = {
        lastCommentOrAttachmentActivity: {
            id: 9979,
            comment: 'Ok boss, in a few minutes',
            doneAt: (0, dayjs_1.default)().subtract(7, 'day').toISOString(),
            event: 'objective.comment',
            user: {
                id: 2,
                name: 'Subordinate A'
            }
        }
    };
    (0, react_1.useEffect)(() => {
        const bookmarkEl = document.getElementById('bookmark-' + 999);
        let offsetTop = 0;
        const allowedClassToCount = ['compact-container', 'list-objectives-body'];
        const countOffsetTop = (element) => {
            if (element.classList.contains('main-wrapper-illustration')) {
                return;
            }
            for (const className of allowedClassToCount) {
                if (element.classList.contains(className)) {
                    offsetTop += element.offsetTop;
                }
            }
            countOffsetTop(element.parentElement);
        };
        countOffsetTop(bookmarkEl);
        const wrapperEl = document.querySelector('.main-wrapper-illustration');
        const svgContainer = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        const circleBullet = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        const pathElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        circleBullet.setAttribute('cx', '0');
        circleBullet.setAttribute('cy', '100');
        circleBullet.setAttribute('r', '6');
        circleBullet.setAttribute('stroke', 'none');
        circleBullet.setAttribute('fill', 'var(--base-600)');
        const circleBulletShadow = circleBullet.cloneNode(true);
        circleBulletShadow.setAttribute('opacity', '0.20');
        circleBulletShadow.setAttribute('r', '10');
        path.setAttribute('d', 'M 444 -3 L 453 3 L 444 9 z');
        path.style.fill = 'var(--base-600)';
        g.appendChild(path);
        g.appendChild(circleBullet);
        g.appendChild(circleBulletShadow);
        pathElement.setAttribute('d', 'm 0 100 l 0 -80 c 0 -18, 20 -18, 20 -18 L 444 3 ');
        pathElement.setAttribute('stroke', 'var(--base-600)');
        pathElement.setAttribute('fill', 'none');
        pathElement.setAttribute('stroke-width', '2px');
        const newElement = document.createElement('div');
        newElement.style.position = 'absolute';
        newElement.style.height = 100 + 'px';
        newElement.style.width = 444 + 'px';
        newElement.style.zIndex = '1';
        newElement.style.left = 60 + 'px';
        newElement.style.top = offsetTop - 90 + 'px';
        svgContainer.appendChild(pathElement);
        svgContainer.appendChild(g);
        svgContainer.setAttribute('width', 444 + 'px');
        svgContainer.setAttribute('height', 100 + 'px');
        svgContainer.style.overflow = 'visible';
        newElement.appendChild(svgContainer);
        wrapperEl === null || wrapperEl === void 0 ? void 0 : wrapperEl.insertBefore(newElement, wrapperEl.children[0]);
    }, []);
    return (react_1.default.createElement("div", { className: "flex items-center flex-col" },
        react_1.default.createElement("p", { className: "typography-h700 text-n-900 mb-[40px]" }, (0, HelperUtils_1.getObjectiveLocale)(`You don't have any highlighted goals now`).replace('goals', (0, HelperUtils_1.getObjectiveLocale)('Goals').toLowerCase())),
        react_1.default.createElement("div", { className: "flex flex-row relative main-wrapper-illustration" },
            react_1.default.createElement("div", { className: "w-[440px] mr-[80px]" },
                react_1.default.createElement("div", { className: "bg-n-000 h-[40px] py-[12px] pl-[16px] rounded-[4px] mb-[8px]" },
                    react_1.default.createElement("p", { className: "typography-h400 text-n-900" }, (0, HelperUtils_1.getObjectiveLocale)(`All ${(0, HelperUtils_1.getObjectiveLocale)('Goals')}`))),
                react_1.default.createElement(GoalCard, { objValue: Object.assign(Object.assign({}, newObj), { id: 991, name: 'Goal 1' }) }),
                react_1.default.createElement("div", { className: "mb-[8px]" }),
                react_1.default.createElement(GoalCard, { objValue: Object.assign(Object.assign({}, newObj), { id: 999, name: 'Goal 2' }) })),
            react_1.default.createElement("div", { className: "w-[440px] mr-[80px]" },
                react_1.default.createElement("div", { className: "bg-n-000 h-[40px] py-[12px] pl-[16px] rounded-[4px] mb-[8px]" },
                    react_1.default.createElement("p", { className: "typography-h400 text-n-900" }, (0, HelperUtils_1.getObjectiveLocale)('Highlights'))),
                react_1.default.createElement(GoalCard, { objValue: Object.assign(Object.assign({}, newObj), { id: 998, name: 'Goal 2', isHighlighted: true }), showActivity: true, activityData: activityData })))));
};
const GoalCard = (_a) => {
    var { objValue } = _a, rest = __rest(_a, ["objValue"]);
    return (react_1.default.createElement("div", { className: "list-objectives-body cursor-pointer bg-n-000 w-[440px]" },
        react_1.default.createElement(Objective_1.default, Object.assign({ level: 1, isParent: true, clusters: [
                'valueLastUpdatedAt',
                'startDate',
                'dueDate',
                'complexity',
                'rollUp',
                'parent',
                'recurrence',
                'assignee',
                'assigner'
            ], customListBadge: ['owner', 'history'], cardModel: "goal-list", objective: objValue, isReadOnly: true }, rest))));
};
exports.default = HighlightedIllustration;
